import React, { forwardRef, useEffect, useState } from 'react';
import { Button, Card, CardActions, CardContent, Checkbox, FormControlLabel, FormGroup, Grid } from '@mui/material';
import { useStateValue } from '../StateProvider';
import StepButtons from '../components/StepButtons';
import { actionTypes } from '../reducer';
import { Download, Visibility } from '@mui/icons-material';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import jsPDF from 'jspdf';
import { Worker } from '@react-pdf-viewer/core';
import { Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { getFilePlugin } from '@react-pdf-viewer/get-file';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50%',
  height: '70%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  overflow: 'scroll',
}

const style2 = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80vw',
  height: '90vh',
  bgcolor: 'background.paper',
  boxShadow: 24,
  overflow: 'hidden',
}

function Agreements({ },ref) {
  const [{ applicantDetails }, dispatch] = useStateValue();
  const [electronic_communications_disclosure, setElectronic_communications_disclosure] = useState(applicantDetails?.electronic_communications_disclosure ? applicantDetails?.electronic_communications_disclosure : false);
  const [star_disclosure, setStar_disclosure] = useState(applicantDetails?.star_disclosure ? applicantDetails?.star_disclosure : false);
  const [tms_agreement, setTMS_agreement] = useState(applicantDetails?.tms_agreement ? applicantDetails?.tms_agreement : false);
  const [openECD, setOpenECD] = React.useState(false);
  const [openSD, setOpenSD] = React.useState(false);
  const [agreedECD, setAgreedECD] = React.useState(true);
  const [agreedSD, setAgreedSD] = React.useState(true);
  const [agreedTMS, setAgreedTMS] = React.useState(true);
  const [abad, setOpenABAD] = React.useState(false);
  const [tms, setOpenTMS] = React.useState(false);
  const [tabbpd, setOpenTABBPD] = React.useState(false);
  const [agreementChecked, setAgreementChecked] = useState(false);
  const [timeStamp, setTimeStamp] = useState(applicantDetails?.electronic_communications_disclosure_agree ? applicantDetails?.electronic_communications_disclosure_agree : null);


  const handleCloseECD = () => setOpenECD(false);
  const handleCloseSD = () => setOpenSD(false);

  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const getFilePluginInstance = getFilePlugin();

  const onUpdateDocumentsInfo = () => {
    let validation = validate();
    dispatch({
      type: actionTypes.SET_APPLICANT_DETAILS,
      applicantDetails: {
        ...applicantDetails,
        electronic_communications_disclosure: electronic_communications_disclosure,
        electronic_communications_disclosure_agree: timeStamp
      },
    });
    return validation;
  }

  useEffect(() => {
      const viewedAgreementECD = JSON.parse(localStorage.getItem('disableAgreementECD'));
      if (!viewedAgreementECD) {
        setAgreedECD(viewedAgreementECD);
      } 
      if (viewedAgreementECD === null) {
        setAgreedECD(true);
      }
  }, [])
  
  const handleOpenECD = () => {
    localStorage.setItem('disableAgreementECD', JSON.stringify(false));
    setOpenECD(true);
    setAgreedECD(false);
  }

  const handleOpenSD = () => {
    setOpenSD(true);
    setAgreedSD(false);
  }

  // const handleOpenABAD = () => {
  //   setOpenABAD(true);
  // }

  // const handleOpenTMS = () => {
  //   setOpenTMS(true);
  // }

  // const handleOpenTABBPD = () => {
  //   setOpenTABBPD(true);
  // }


  const validate = () => {
    let validateSuccess = { error: false, msg: "" };
    if (!electronic_communications_disclosure /* || !star_disclosure || !tms_agreement */)
      return {
        error: true, msg: "Please review and check all Agreements."
      };
    return validateSuccess;
  }
  const generateECD = () => {
    setAgreedECD(false);
    var doc = new jsPDF('p', 'px', 'a4', true);
    var source = document.getElementById('ecd');
    doc.html(source, {
      callback: function (doc) {
        doc.save('ElectronicCommunicationDisclosure.pdf');
      }
    });
  }
  const generateSD = () => {
    setAgreedSD(false)
    var doc = new jsPDF('p', 'px', 'a4', true);
    var source = document.getElementById('sd');
    doc.html(source, {
      callback: function (doc) {
        doc.save('STARDisclosure.pdf');
      }
    });
  }

  const handleOpenABAD = () => {
    setOpenABAD(true);
  }
  const handleCloseABAD = () => setOpenABAD(false);

  const handleOpenTMS = () => {
    setAgreedTMS(false);
    setOpenTMS(true);
  }
  const handleCloseTMS = () => setOpenTMS(false);

  const handleOpenTABBPD = () => {
    setOpenTABBPD(true);
  }
  const handleCloseTABBPD = () => setOpenTABBPD(false);

  const onDownloadABAD = () => {
    const link = document.createElement("a");
    link.download = `Analyzed_Business_Account_Disclosure.pdf`;
    link.href = require("..//assets/pdfs/Analyzed_Business_Account_Disclosure.pdf");
    link.click();
  };
  const onDownloadTMS = () => {
    setAgreedTMS(false);
    const link = document.createElement("a");
    link.download = `TMS_Agreement.pdf`;
    link.href = require("..//assets/pdfs/TMS_Agreement.pdf");
    link.click();
  };

  const onDownloadTABBPD = () => {
    const link = document.createElement("a");
    link.download = `TAB_Bank_Privacy_Disclosure.pdf`;
    link.href = require("..//assets/pdfs/TAB_Bank_Privacy_Disclosure.pdf");
    link.click();
  };

  const handleChangeECDisclosureAgree = (event) => {
    const checked = event.target.checked;
    setAgreementChecked(checked);
    setElectronic_communications_disclosure(!electronic_communications_disclosure);
    if (checked && !timeStamp) {
      setTimeStamp(new Date().toISOString());
    }
  }

    //console.log("Electronic Disclosure Agreement", electronic_communications_disclosure);
    //console.log("Electronic Disclosure Agreement TIME", timeStamp);

  return (

    <Grid container height={'90vh'}>
      <Grid container item spacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item xs={12}>
          <Typography sx={{ textAlign: 'start' }}>Disclosures</Typography>
        </Grid>
        <Grid item xs={12} md={6} lg={5} xl={5}>
          <div>
            <Card>
              <CardContent sx={{ background: '#f3f3f3 ', color: '#000000', padding: 5, height: '50px' }}>
                <FormGroup>
                  <FormControlLabel control={
                    <Checkbox
                      disabled={agreedECD}
                      name='electronic_communications_disclosure'
                      onChange={handleChangeECDisclosureAgree}
                      checked={electronic_communications_disclosure} />
                  } label="I agree to the Electronic Communications Disclosure" />

                </FormGroup>
              </CardContent>
              <CardActions sx={{
                display: "flex",
                justifyContent: "space-between"
              }}>
                <Button style={{ fontSize: '12px' }} variant="outlined" onClick={handleOpenECD} startIcon={<Visibility />}>
                  View
                </Button>
                <Button style={{ fontSize: '12px' }} onClick={generateECD} variant="outlined" startIcon={<Download />}>
                  Download
                </Button>
              </CardActions>
            </Card>
            <div id="content" style={{ display: 'none' }} >
              <div id="ecd" style={{ width: '420px', padding: '10px', fontSize: '6px' }}>
                <p>
                  <b style={{ fontSize: '10px' }}>Electronic Communication Disclosure</b>
                  <br />
                  <br />
                  Effective Date: August 10, 2018
                  <br />
                  <br />
                  <b>Please read this Electronic Communications Disclosure ("eCommunications Disclosure")
                    thoroughly - It contains important information about your legal rights.</b>
                  <br />
                  This eCommunications Disclosure covers your Transportation Alliance Bank account access, either
                  currently or in the future, whether accessed through a personal computer or mobile device
                  (sometimes referred to as “Mobile App”), our websites, or other electronic means. The term "TAB
                  Bank" or “TAB” or "we" or "us" or "our" in this Notice refers to Transportation Alliance Bank, inc. dba
                  TAB Bank. The words "I", "you" and "your" mean each account holder, product owner and/or service
                  user identified on an account, product or service.
                  <br />
                  <br />
                  <b>(1) Your Legal Rights</b>
                  <br />
                  <br />
                  Certain laws and regulations require us to provide specific information to you in writing, which means
                  you have a right to receive that information on paper. We may provide such information to you
                  electronically if we first present this eCommunications Disclosure and obtain your consent to receive
                  the information electronically. Your consent will also apply to any other person named on your
                  account, product or service, subject to applicable law. Since our accounts, products or services are
                  provided online and use electronic means to deliver some of this information, you must consent to
                  this eCommunications Disclosure in order to use these services. At times, we may still send you
                  paper communications, but as a basic proposition we need to know that you are willing to receive
                  communications electronically that we may otherwise be required to provide on paper and that you
                  have the hardware and software needed to access to this information (and note that in Section No. 3
                  below, we explain ways to obtain selected disclosures or other information on paper even after you
                  have consented to this eCommunications Disclosure).
                  <br />
                  <br />
                  <b>(2) Types of Electronic Communications You Will Receive</b>
                  <br />
                  <br />
                  You understand and agree that we may provide to you in electronic format only, by posting the
                  information on the website where you access your accounts, products or services, through e-mail or
                  other electronic means, agreements, disclosures, notices, and other information and
                  communications regarding your accounts, services and products, the use of our websites or our
                  other electronic services, your relationship with us, and/or other programs, products or services that
                  are or may be in the future made available to you (collectively, "Communications"). Such
                  Communications may include, but are not limited to:
                  <br />
                  <br />
                  • This eCommunications Disclosure and any updates;
                  <br />
                  <br />
                  • The Electronic Disclosure Consent, and Online Banking and Bill Pay Agreement, other
                  service or user agreements for access to our websites or other electronic services, all
                  updates to these agreements and all disclosures, notices and other communications
                  regarding transactions you make through websites or our other electronic services;
                  <br />
                  <br />
                  • Disclosures, agreements, notices and other information related to the opening or initiation
                  of an account, product or service including, but not limited to, account agreements, fee
                  schedules or other disclosures or notices that may be required by the Truth in Lending Act,
                  the Equal Credit Opportunity Act, the Fair Credit Reporting Act, the Gramm Leach Bliley Act,
                  or other applicable federal or state laws and regulations;
                  <br />
                  <br />
                  • Periodic, annual, monthly or other statements, disclosures and notices relating to the
                  maintenance or operation of an account, product or service including, but not limited to
                  account information, account activity, account inactivity, payments made or due, or other
                  statements, disclosures or notices that may be required by the Electronic Fund Transfer Act,
                  Truth in Lending Act, the Equal Credit Opportunity Act, the Fair Credit Reporting Act, the
                  Gramm Leach Bliley Act or other applicable federal or state laws and regulations;
                  <br />
                  <br />
                  • Any notice or disclosure regarding an account, product or service fee, such as a late fee,
                  an overdraft fee, an over limit fee, a fee for a draft, check or electronic debit returned for any
                  reason, such as insufficient funds fee or a fee as a result of a stop payment order;
                  <br />
                  <br />
                  • Any notice of the addition of new terms and conditions or the deletion or amendment of
                  existing terms and conditions applicable to accounts, products or services you obtain from
                  us;
                  <br />
                  <br />
                  • Our Privacy Policy and other privacy statements or notices (by posting such notices on our
                  website);
                  <br />
                  <br />
                  • Certain information or forms that we request from you and ask you to submit electronically.
                  <br />
                  <br />
                  • Certain tax statements or notices that we are legally required to provide to you, such as the
                  annual IRS interest statements; and
                  <br />
                  <br />
                  • Certain information or forms that we request from you and ask you to submit electronically,
                  such as signature cards, W-9s, or other agreements.
                  <br />
                  <br />
                  <b>(3) Types of Communications You Will Receive in Paper</b>
                  <br />
                  <br />
                  This eCommunications Disclosure does not apply to any communications that we determine, in our
                  sole discretion, that we are required to deliver in paper form under applicable law or that you should
                  receive in paper rather than electronic form.
                  <br />
                  <br />
                  Such communications shall be mailed to the primary address we show for you in our records or
                  otherwise delivered as required by law or the governing agreement.
                  <br />
                  <br />
                  <b>(4) Electronic Signatures</b>
                  <br />
                  <br />
                  You acknowledge that by clicking “Submit” or similar buttons on this application, you are indicating
                  your intent to receive electronic communications about your application for a TAB Bank account and
                  that this shall constitute your signature.
                  <br />
                  <br />
                  <b>(5) Hardware and Software Requirements</b>
                  <br />
                  <br />
                  While you may be able to access and retain the Communications using other hardware and
                  software, we currently support the following minimum requirements:
                  To receive TAB Bank Account information electronically and retain it, you need:
                  <br />
                  1. A computer with a connection to the Internet
                  <br />
                  2. An email address
                  <br />
                  3. A printer, hard drive or other storage device for downloading and retaining the Account
                  Information
                  <br />
                  4. Adobe Reader 11.0 or higher or other software that allows you to view and print PDF
                  documents
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  On desktop computers:
                  <br />
                  1. Windows (7 or higher) or Mac OS Y
                  <br />
                  2. A compatible web browser that supports XHTML 1.0, SSL/TLS encryption, and JavaScript. Many
                  browsers work with tabbank.com, but for best results, we recommend you use: Microsoft Edge or
                  Internet Explorer 11, Safari 9 or higher or the latest generally available version of Mozilla Firefox or
                  Google Chrome.
                  <br />
                  <br />
                  On tablet devices:
                  <br />
                  1. Android (4.4 and 5.0 or higher) and iOS (9.0)
                  <br />
                  2. Native browsers for the supported Android and iOS operating systems and the latest generally
                  available versions of devices internet browser.
                  <br />
                  <br />
                  For browser-based services on mobile phones:
                  <br />
                  1. Android (4.4 and 5.0 or higher) and iOS (9.0)
                  <br />
                  2. Native browsers for the supported Android and iOS operating systems and the latest generally
                  available versions of the phones internet browser. TAB Bank recommends you maintain updated
                  anti-virus protection on your computer at all times. Prior to enrolling in the Online Banking Service
                  and accepting the electronic version of this Agreement, you should verify that you have the required
                  hardware and software necessary to access the Online Banking Service and to retain a copy of this
                  Agreement. If we revise hardware and software requirements, and if there is a material impact to
                  your ability to access the Online Banking Service, we will give you advance notice of these changes
                  and provide you an opportunity to cancel the service and/or change your method of receiving
                  electronic disclosures (e.g. change to paper format vs. an electronic format) without the imposition of
                  any fees.
                  <br />
                  <br />
                  As new browsers and operating systems emerge, TAB will seek to utilize new technology to create a
                  better user experience. As such, current minimum requirements are subject to change.
                  <br />
                  <br />
                  <b>(6) How to Withdraw Your Consent to this eCommunications Disclosure</b>
                  <br />
                  <br />
                  Subject to applicable law, you may withdraw your consent to this eCommunications Disclosure by
                  contacting us at info@tabbank.com or 800-355-3063. You will not be charged a fee for withdrawal of
                  your consent. If you withdraw your consent to this eCommunications Disclosure, we may stop
                  providing you with Communications electronically and we may terminate your TAB Bank deposit
                  account. Your withdrawal of consent is effective only after you have communicated your withdrawal
                  to TAB by calling the appropriate customer service phone numbers and TAB has had a reasonable
                  period of time to act upon your withdrawal. Your consent shall remain in force until withdrawn in the
                  manner provided in this section.                 <br />
                  <br />
                  <b>(7) Obtaining Copies of Electronic Communications.</b>
                  <br />
                  <br />
                  You may print or make a copy of Communications by using the "Print" button (or otherwise using
                  your printing functionality) or saving a copy – do this when you first review the Communications
                  because after submission we do not necessarily keep them all in a place that you can access. Upon
                  request, we will provide you with a paper copy of any Communications provided electronically by us
                  to you pursuant to this eCommunications Disclosure, provided we receive your request within 12
                  months after the date the Communication was first made available to you electronically. You may
                  request a paper copy of these Communications by contacting us at info@tabbank.com or 800-355-
                  3063. Be sure to specify your account, service or product identification number, as applicable, the
                  specific Communication for which you are requesting a paper copy, and the address to which it
                  should be mailed. We may charge fees for paper copies of account records or paper statements,
                  see applicable fee schedule.
                  <br />
                  <br />
                  account, service or product identification number, as applicable, the specific Communication for which you are requesting a paper copy, and the address to
                  which it should be mailed. We may charge fees for paper copies of account records or paper statements, see applicable fee schedule.
                  <br />
                  <br />
                  <b>(8) Updating Your Contact Information</b>
                  <br />
                  <br />
                  In the event that your e-mail address or other contact information is changed, you must notify us of
                  such changes immediately by accessing your account through the TAB Bank website, contacting us
                  at info@tabbank.com or 800-355-3063.
                  If you fail to update or change an incorrect or invalid e-mail address or other contact information, you
                  understand and agree that any Communications shall nevertheless be deemed to have been
                  provided to you if they were made available to you in electronic form on our websites, e-mailed to
                  the e-mail address we have for you in our records, or delivered through other electronic means.
                  <br />
                  <br />
                  <b>(9) Retain Copies for Your Records </b>
                  <br />
                  <br />
                  We recommend that you print or download a copy of this eCommunications Disclosure, the
                  applicable service agreement and all other Communications to retain for your permanent records.               </p>
              </div>
              <div id="sd" style={{ width: '420px', padding: '10px', fontSize: '8px' }}>
                <p>
                  {/* <b style={{ fontSize: '10px' }}>STARP Disclosure</b> */}
                  <br />
                  <br />
                  <b>By completing and submitting this application online, all applicants certify to the following:</b>
                  <br />
                  The information set forth in this application and in the documents, schedules, reports, statements, and / or other information provided to TAB Bank with or pursuant to this application are full, true, correct, and complete and accurately reflect such information on the date(s) thereof; that TAB Bank is authorized to request, receive, and verify credit reports and other financial information regarding applicant and its business applicant and its owners/officers that TAB Bank deems necessary and appropriate; that TAB Bank is authorized to execute in the name of the Business and the undersigned person(s) and file against the Business and undersigned person(s) in favor of TAB Bank financing statements with respect to the Business and undersigned person(s) assets; and that TAB Bank is
                  authorized to inquire of, investigate, confirm, and verify any information contained in this application, in any documents, schedules, reports, statements, and / or other information provided under or pursuant to this application and the subsequent maintenance and review of any account opened as a result of this application, or learned by TAB Bank as part of its investigation and review
                  <br />
                  <br />
                  <b>IMPORTANT INFORMATION ABOUT PROCEDURES FOR OPENING A NEW BUSINESS ACCOUNT-</b>
                  <br />
                  To help the government fight the funding of terrorism and money laundering activities, federal law requires all financial institutions to obtain, verify, and record information that identifies each person who applies for an account. What this means for you: When you apply for an account, we will ask for your name, address, date of birth, and other information that will allow us to identify you. We may also ask to see your driver's license, social security card, or other identifying documents.
                </p>
              </div>
            </div>

            <div id="elementH"></div>
            <Modal
              open={openECD}
              onClose={handleCloseECD}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} xs={2}>
                <Grid container fullWidth>
                  <Grid item xs={10}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                      <b>Electronic Communication Disclosure</b>
                    </Typography>
                  </Grid>
                  <Grid onClick={handleCloseECD} item xs={2} sx={{ textAlign: 'end', margin: 'auto', fontSize: '20px' }}>X</Grid>
                </Grid>
                <p sx={{ mt: 2 }}>
                  <b>Electronic Communication Disclosure</b>
                  &nbsp;Effective Date: August 10, 2018
                  <br />
                  <br />
                  <b>Please read this Electronic Communications Disclosure ("eCommunications Disclosure")
                    thoroughly - It contains important information about your legal rights.</b>
                  <br />
                  This eCommunications Disclosure covers your Transportation Alliance Bank account access, either
                  currently or in the future, whether accessed through a personal computer or mobile device
                  (sometimes referred to as “Mobile App”), our websites, or other electronic means. The term "TAB
                  Bank" or “TAB” or "we" or "us" or "our" in this Notice refers to Transportation Alliance Bank, inc. dba
                  TAB Bank. The words "I", "you" and "your" mean each account holder, product owner and/or service
                  user identified on an account, product or service.
                  <br />
                  <br />
                  <b>(1) Your Legal Rights</b>
                  <br />
                  <br />
                  Certain laws and regulations require us to provide specific information to you in writing, which means
                  you have a right to receive that information on paper. We may provide such information to you
                  electronically if we first present this eCommunications Disclosure and obtain your consent to receive
                  the information electronically. Your consent will also apply to any other person named on your
                  account, product or service, subject to applicable law. Since our accounts, products or services are
                  provided online and use electronic means to deliver some of this information, you must consent to
                  this eCommunications Disclosure in order to use these services. At times, we may still send you
                  paper communications, but as a basic proposition we need to know that you are willing to receive
                  communications electronically that we may otherwise be required to provide on paper and that you
                  have the hardware and software needed to access to this information (and note that in Section No. 3
                  below, we explain ways to obtain selected disclosures or o
                  <br />
                  <br />
                  <b>(2) Types of Electronic Communications You Will Receive</b>
                  <br />
                  <br />
                  You understand and agree that we may provide to you in electronic format only, by posting the
                  information on the website where you access your accounts, products or services, through e-mail or
                  other electronic means, agreements, disclosures, notices, and other information and
                  communications regarding your accounts, services and products, the use of our websites or our
                  other electronic services, your relationship with us, and/or other programs, products or services that
                  are or may be in the future made available to you (collectively, "Communications"). Such
                  Communications may include, but are not limited to:
                  <br />
                  <br />
                  <p class="ml-2">
                    • eCommunications Disclosure and any updates;
                    <br />
                    <br />
                    • The Electronic Disclosure Consent, and Online Banking and Bill Pay Agreement, other
                    service or user agreements for access to our websites or other electronic services, all
                    updates to these agreements and all disclosures, notices and other communications
                    regarding transactions you make through websites or our other electronic services;
                    <br />
                    <br />
                    • Disclosures, agreements, notices and other information related to the opening or initiation
                    of an account, product or service including, but not limited to, account agreements, fee
                    schedules or other disclosures or notices that may be required by the Truth in Lending Act,
                    the Equal Credit Opportunity Act, the Fair Credit Reporting Act, the Gramm Leach Bliley Act,
                    or other applicable federal or state laws and regulations;
                    <br />
                    <br />
                    • Periodic, annual, monthly or other statements, disclosures and notices relating to the
                    maintenance or operation of an account, product or service including, but not limited to
                    account information, account activity, account inactivity, payments made or due, or other
                    statements, disclosures or notices that may be required by the Electronic Fund Transfer Act,
                    Truth in Lending Act, the Equal Credit Opportunity Act, the Fair Credit Reporting Act, the
                    Gramm Leach Bliley Act or other applicable federal or state laws and regulations;
                    <br />
                    <br />
                    • Any notice or disclosure regarding an account, product or service fee, such as a late fee,
                    an overdraft fee, an over limit fee, a fee for a draft, check or electronic debit returned for any
                    reason, such as insufficient funds fee or a fee as a result of a stop payment order;
                    <br />
                    <br />
                    • Any notice of the addition of new terms and conditions or the deletion or amendment of
                    existing terms and conditions applicable to accounts, products or services you obtain from
                    us;
                    <br />
                    <br />
                    • Our Privacy Policy and other privacy statements or notices (by posting such notices on our
                    website);
                    <br />
                    <br />
                    • Certain information or forms that we request from you and ask you to submit electronically.
                    <br />
                    <br />
                    • Certain tax statements or notices that we are legally required to provide to you, such as the
                    annual IRS interest statements; and
                    <br />
                    <br />
                    • Certain information or forms that we request from you and ask you to submit electronically,
                    such as signature cards, W-9s, or other agreements.
                  </p>
                  <b>(3) Types of Communications You Will Receive in Paper </b>
                  <br />
                  <br />
                  This eCommunications Disclosure does not apply to any communications that we determine, in our
                  sole discretion, that we are required to deliver in paper form under applicable law or that you should
                  receive in paper rather than electronic form.
                  <br />
                  <br />
                  Such communications shall be mailed to the primary address we show for you in our records or
                  otherwise delivered as required by law or the governing agreement.
                  <br />
                  <br />
                  <b>(4) Electronic Signatures</b>
                  <br />
                  <br />
                  You acknowledge that by clicking “Submit” or similar buttons on this application, you are indicating
                  your intent to receive electronic communications about your application for a TAB Bank account and
                  that this shall constitute your signature.
                  <br />
                  <br />
                  <b>(5) Hardware and Software Requirements </b>
                  <br />
                  <br />
                  While you may be able to access and retain the Communications using other hardware and
                  software, we currently support the following minimum requirements:
                  <br />
                  To receive TAB Bank Account information electronically and retain it, you need:
                  <br />
                  1. A computer with a connection to the Internet
                  <br />
                  2. An email address
                  <br />
                  3. A printer, hard drive or other storage device for downloading and retaining the Account
                  Information
                  <br />
                  4. Adobe Reader 11.0 or higher or other software that allows you to view and print PDF
                  documents
                  <br />
                  <br />
                  On desktop computers:
                  1. Windows (7 or higher) or Mac OS Y
                  <br />
                  2. A compatible web browser that supports XHTML 1.0, SSL/TLS encryption, and JavaScript. Many
                  browsers work with tabbank.com, but for best results, we recommend you use: Microsoft Edge or
                  Internet Explorer 11, Safari 9 or higher or the latest generally available version of Mozilla Firefox or
                  Google Chrome.
                  <br />
                  <br />
                  On tablet devices:
                  <br />
                  1. Android (4.4 and 5.0 or higher) and iOS (9.0)
                  <br />
                  2. Native browsers for the supported Android and iOS operating systems and the latest generally
                  available versions of devices internet browser.
                  <br />
                  <br />
                  For browser-based services on mobile phones:
                  <br />
                  1. Android (4.4 and 5.0 or higher) and iOS (9.0)
                  <br />
                  2. Native browsers for the supported Android and iOS operating systems and the latest generally
                  available versions of the phones internet browser. TAB Bank recommends you maintain updated
                  anti-virus protection on your computer at all times. Prior to enrolling in the Online Banking Service
                  and accepting the electronic version of this Agreement, you should verify that you have the required
                  hardware and software necessary to access the Online Banking Service and to retain a copy of this
                  Agreement. If we revise hardware and software requirements, and if there is a material impact to
                  your ability to access the Online Banking Service, we will give you advance notice of these changes
                  and provide you an opportunity to cancel the service and/or change your method of receiving
                  electronic disclosures (e.g. change to paper format vs. an electronic format) without the imposition of
                  any fees.
                  <br />
                  <br />
                  As new browsers and operating systems emerge, TAB will seek to utilize new technology to create a
                  better user experience. As such, current minimum requirements are subject to change.
                  <br />
                  <br />
                  <b>(6) How to Withdraw Your Consent to this eCommunications Disclosure </b>
                  <br />
                  <br />
                  Subject to applicable law, you may withdraw your consent to this eCommunications Disclosure by
                  contacting us at info@tabbank.com or 800-355-3063. You will not be charged a fee for withdrawal of
                  your consent. If you withdraw your consent to this eCommunications Disclosure, we may stop
                  providing you with Communications electronically and we may terminate your TAB Bank deposit
                  account. Your withdrawal of consent is effective only after you have communicated your withdrawal
                  to TAB by calling the appropriate customer service phone numbers and TAB has had a reasonable
                  period of time to act upon your withdrawal. Your consent shall remain in force until withdrawn in the
                  manner provided in this section.
                  <br />
                  <br />
                  <b>(7) Obtaining Copies of Electronic Communications. </b>
                  <br />
                  <br />
                  You may print or make a copy of Communications by using the "Print" button (or otherwise using
                  your printing functionality) or saving a copy – do this when you first review the Communications
                  because after submission we do not necessarily keep them all in a place that you can access. Upon
                  request, we will provide you with a paper copy of any Communications provided electronically by us
                  to you pursuant to this eCommunications Disclosure, provided we receive your request within 12
                  months after the date the Communication was first made available to you electronically. You may
                  request a paper copy of these Communications by contacting us at info@tabbank.com or 800-355-
                  3063. Be sure to specify your account, service or product identification number, as applicable, the
                  specific Communication for which you are requesting a paper copy, and the address to which it
                  should be mailed. We may charge fees for paper copies of account records or paper statements,
                  see applicable fee schedule.
                  <br />
                  <br />
                  <b>(8) Updating Your Contact Information</b>
                  <br />
                  <br />
                  In the event that your e-mail address or other contact information is changed, you must notify us of
                  such changes immediately by accessing your account through the TAB Bank website, contacting us
                  at info@tabbank.com or 800-355-3063.
                  <br />
                  <br />
                  If you fail to update or change an incorrect or invalid e-mail address or other contact information, you
                  understand and agree that any Communications shall nevertheless be deemed to have been
                  provided to you if they were made available to you in electronic form on our websites, e-mailed to
                  the e-mail address we have for you in our records, or delivered through other electronic means.
                  <br />
                  <br />
                  <b>(9) Retain Copies for Your Records </b>
                  <br />
                  <br />
                  We recommend that you print or download a copy of this eCommunications Disclosure, the
                  applicable service agreement and all other Communications to retain for your permanent records.
                </p>
              </Box>
            </Modal>
          </div>
        </Grid>
      </Grid>
      {/* <Grid container item spacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }} marginTop={5}>
        <Grid item xs={12} sm={12} md={12} lg={10} xl={10}>
          <Card>
            <CardContent sx={{ background: '#fff ', color: '#000000', padding: 5 }}>
              By submitting this application, Applicant acknowledges they will be required to pay Transportation Alliance Bank, Inc. d/b/a TAB Bank 
              (TAB) a non-refundable due diligence fee equal to two hundred fifty dollars ($250.00) from the initial funding, to begin the credit 
              review process. Additionally, the applicant acknowledges the due diligence fee will remain due and payable to TAB in the event the 
              fee is not collected from the initial funding for any reason.
              <br />
              <br />
              By applying for any service, you agree that this application contains
              provisions that apply to any and all services that we provide to you, and it
              contains provisions that apply to specific services including, but not limited
              to, factoring, accounts receivable finance, and business treasury services.
              Your use of any service also evidences your agreement to be bound to the
              applicable terms and conditions of each.
            </CardContent>
          </Card>
        </Grid>
      </Grid> */}
      <Grid container>
      </Grid>
      <Grid item xs={10}>
        <StepButtons updateInfo={onUpdateDocumentsInfo} ref={ref} />
      </Grid>
    </Grid>

  )
}

export default forwardRef(Agreements)
